import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay, priceFormat } from "../../functions";
import Icon from "../../components/Icons";
import isEqual from "lodash/isEqual";

import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class UpsellTotalCartPrice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      finalPriceFormatted: "...",
    };

    this.totalCart_product = 95;
    this.totalCart_shipping = 30;
    this.totalCart_tax = 13;
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settingsnextProp?.settings) ||
      !isEqual(this.state, nextState)
    ) {
      return true;
    }

    return false;
  }

  componentWillReceiveProps(props) {
    if (
      props.payload &&
      props.payload.datas &&
      this.props.payload.datas &&
      (props.payload.datas.totalCart_product !==
        this.props.payload.datas.totalCart_product ||
        props.payload.datas.totalCart_shipping !==
          this.props.payload.datas.totalCart_shipping ||
        props.payload.datas.totalCart_tax !==
          this.props.payload.datas.totalCart_tax)
    ) {
      var price = 0;

      if (props.payload.datas.totalCart_product)
        price = price + this.totalCart_product;

      if (props.payload.datas.totalCart_shipping)
        price = price + this.totalCart_shipping;

      if (props.payload.datas.totalCart_tax) price = price + this.totalCart_tax;

      priceFormat(price).then((data) => {
        this.setState({
          finalPriceFormatted: data,
        });
      });
    }
  }

  componentDidMount() {
    if (this.props.payload && this.props.payload.datas) {
      var price = 0;

      if (this.props.payload.datas.totalCart_product)
        price = price + this.totalCart_product;

      if (this.props.payload.datas.totalCart_shipping)
        price = price + this.totalCart_shipping;

      if (this.props.payload.datas.totalCart_tax)
        price = price + this.totalCart_tax;

      priceFormat(price).then((data) => {
        this.setState({
          finalPriceFormatted: data,
        });
      });
    }
  }

  _initTitle = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    let cartPriceLabel = "";

    if (payload.datas) {
      if (payload.datas["cartPriceLabel_" + this.props.currentLang])
        cartPriceLabel =
          payload.datas["cartPriceLabel_" + this.props.currentLang];
      else if (payload.datas["cartPriceLabel"])
        cartPriceLabel = payload.datas["cartPriceLabel"];
    }

    const { cartPriceColor } = (payload && payload.datas) || {
      cartPriceColor: "#000",
    };

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            {cartPriceLabel && (
              <h3 style={cssSettingsText}>
                {cartPriceLabel.split("%%")[0]}
                {cartPriceLabel.includes("%%") && (
                  <span
                    className="qty-available"
                    style={{ color: cartPriceColor }}
                  >
                    {this.state.finalPriceFormatted}
                  </span>
                )}
                {cartPriceLabel.includes("%%")
                  ? cartPriceLabel.split("%%")[1]
                  : ""}
              </h3>
            )}
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initTitle()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initTitle()}
      </Draggable>
    );
  }
}

UpsellTotalCartPrice.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(UpsellTotalCartPrice);
